import React from 'react';
import { Box, Typography, Pane } from '@fullstory/components';

export const APILabel: React.FC<{ text: string }> = ({ text }) => (
  <Pane data-component="APILabel" backgroundColor="secondary" borderRadius={4}>
    <Box padding={[4, 8]}>
      <Typography variant="mono3" wordBreak="break-all">
        {text}
      </Typography>
    </Box>
  </Pane>
);
